export default __webpack_public_path__ + "static/media/logo.c7e853fe.png";